import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  promotionList: [],
  promotionCatalogList: [],
  promotionDetail: [],
  promotionItemsList: [],
  loading: false,
  error: undefined,
};

const promotionSlice = createSlice({
  name: "promotion",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchPromotionCatalogList(state, action) {
      state.promotionCatalogList = action.payload;
      state.loading = false;
    },
    fetchPromotionList(state, action) {
      state.promotionList = action.payload;
      state.loading = false;
    },
    fetchPromotionDetail(state, action) {
      state.promotionDetail = action.payload;
      state.loading = false;
    },
    fetchPromotionStart(state, action) {
      state.promotionItemsList = action.payload;
      state.loading = false;
    },
  },
});

export const promotionActions = promotionSlice.actions;

export default promotionSlice.reducer;
